import { FormFieldModel } from "../typings";
import { locKeys } from "../components/l10n";

interface SearchFormProps {
  [key: string]: FormFieldModel;
}

export const SearchForm: SearchFormProps = {
  HotelOnly: {
    formFieldName: "destination",
    formFieldLabel: locKeys.hotelDestinationFieldLabel,
    formFieldStid: "hotel-destination",
    typeaheadLob: "HOTELS"
  },
  HotelCar: {
    formFieldName: "destination",
    formFieldLabel: locKeys.hotelDestinationFieldLabel,
    formFieldStid: "hotel-destination",
    typeaheadLob: "HOTELS",
    packageType: "hc"
  },
  HotelFlight: {
    formFieldName: "fh-origin",
    formFieldLabel: locKeys.flightOriginFieldLabel,
    formFieldStid: "fh-origin",
    typeaheadLob: "FLIGHTS",
    packageType: "fh",
    directFlightEnabled: true
  },
  HotelFlightCar: {
    formFieldName: "fhc-origin",
    formFieldLabel: locKeys.flightOriginFieldLabel,
    formFieldStid: "fh-destination",
    typeaheadLob: "FLIGHTS",
    packageType: "fhc",
    directFlightEnabled: true
  }
};
